import { render } from "./AdsetBudgetNonOdaxBlock.vue?vue&type=template&id=8d38c392"
import script from "./AdsetBudgetNonOdaxBlock.vue?vue&type=script&lang=js"
export * from "./AdsetBudgetNonOdaxBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/ui/components/RuleForm/Blocks/AdsetBudgetNonOdaxBlock.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8d38c392"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8d38c392', __exports__)) {
    api.reload('8d38c392', __exports__)
  }
  
  module.hot.accept("./AdsetBudgetNonOdaxBlock.vue?vue&type=template&id=8d38c392", () => {
    api.rerender('8d38c392', render)
  })

}


export default __exports__